import { render } from "./ServiceTableMobile.vue?vue&type=template&id=46421ca8"
import script from "./ServiceTableMobile.vue?vue&type=script&lang=js"
export * from "./ServiceTableMobile.vue?vue&type=script&lang=js"

import "./ServiceTableMobile.vue?vue&type=style&index=0&id=46421ca8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__